export const SMALL_CONTAINER_WIDTH = 480;
export const MIDDLE_CONTAINER_WIDTH = 768;
export const MEDIUM_CONTAINER_WIDTH = 1024;
